import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/layout/AppShell";
import { Spinner } from "@/components/common/Common";
import Login from "@/pages/Login";
import AcceptInvite from "@/pages/AcceptInvite";
import Account from "@/pages/Account";
import Dashboard from "@/pages/Dashboard";
import Templates from "@/pages/Templates";
import Reports from "@/pages/Reports";
import RecruitmentCompanies from "@/pages/RecruitmentCompanies";
import PteCompanies from "@/pages/PteCompanies";
import AdminPage from "@/pages/admin/AdminPage";
import ContractsList from "@/pages/contracts/ContractsList";
import ContractPage from "@/pages/contracts/ContractPage";
import NewContractWizard from "@/pages/contracts/NewContractWizard";
import PipelineBoard from "@/pages/contracts/PipelineBoard";
import ContractorsList from "@/pages/contractors/ContractorsList";
import ContractorProfile from "@/pages/contractors/ContractorProfile";

function Protected({ children }) {
  const { user, appSettings } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-500 gap-2"><Spinner /> Loading…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (appSettings?.mfa_required && !user.mfa_enabled && loc.pathname !== "/account") return <Navigate to="/account?enrol=1" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/contracts" element={<ContractsList />} />
              <Route path="/contracts/new" element={<NewContractWizard />} />
              <Route path="/contracts/board" element={<PipelineBoard />} />
              <Route path="/contracts/:id" element={<ContractPage />} />
              <Route path="/contractors" element={<ContractorsList />} />
              <Route path="/contractors/:id" element={<ContractorProfile />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/recruitment-companies" element={<RecruitmentCompanies />} />
              <Route path="/pte-companies" element={<PteCompanies />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/account" element={<Account />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="light" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
